import { styled } from '@mui/material/styles';

export {
    ScrollableBoxContent as ConsentCheckboxContent,
    ScrollableBoxWrapper as ConsentCheckboxContentWrapper,
} from '../ScrollableTextBox/ScrollableTextBox.styles';

export const ConsentWrapper = styled('div')`
    margin-bottom: 16px;
`;
